import { useContext } from "react";
import { ThemeContext } from "../ThemeContext";
import { useTranslation } from "react-i18next";
import logo1 from '../../assets/reform-logo.svg';   
import logo2 from '../../assets/savvycal-logo.svg';
import logo3 from '../../assets/statamic-logo.svg';
import logo4 from '../../assets/transistor-logo.svg';
import logo5 from '../../assets/tuple-logo.svg';

export const Companies = () => {
    const [theme] = useContext(ThemeContext) as ["light" | "dark", React.Dispatch<React.SetStateAction<"light" | "dark">>];
    const { t } = useTranslation();
    const companies = [
        { id: 1, name: 'Reform logo', logo: logo1 },
        { id: 2, name: 'Savvycal logo', logo: logo2 },
        { id: 3, name: 'Statamic logo ', logo: logo3 },
        { id: 4, name: 'Transistor logo', logo: logo4 },
        { id: 5, name: 'Tuple logo', logo: logo5 },
    ];
    return (
        <div className={`sponsors ${theme} py-12 sm:py-32`}>
            <div className="mx-auto max-w-6xl px-6 lg:px-8">
                <p className="text-center font-semibold text-2xl">{t('sponsors.title')}</p>
                <div className="mx-auto mt-10 grid max-w-lg grid-cols-2 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-3 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
                {companies.map((company) => (
                        <div 
                            key={company.id} 
                            className="flex items-center justify-center"
                        >
                            <img
                                src={company.logo}
                                alt={company.name}
                                className="max-w-full max-h-full object-contain"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>

    )
}
